import React, {SFC, useState} from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import { Typography, makeStyles } from "@material-ui/core";
import AskRalphieForm from "../../Components/Forms/AskRalphieForm";
import {colorInputBorder, colorPrimary, colorSecondary} from "../../Constants/theme";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
        overflow: "scroll",
        height: "90vh",
    },
    containerRoot: {
        position: "relative",
        marginBottom: 55,
        zIndex: 1,
        maxWidth: "630px"
    },
    askRalphieHeaderFont: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        color: colorPrimary,
        marginBottom: "20px"
    },
    askRalphieHeaderFontRelated: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        color: colorPrimary,
        marginBottom: "4px"
    },
    askAboutRalphieWork: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        color: colorPrimary,
        marginTop: "52px",
        marginBottom: "22px"
    },
    submitButton: {
        background: colorSecondary,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "74px",
    },
    relatedQuestion: {
        marginTop: "2px"
    },
    youCanAskFont: {
        fontFamily: "Inter",
        letterSpacing: "0.374px",
        lineHeight: "18px",
        fontSize: "14px",
        color: colorInputBorder
    },
    bottomDisclaimer: {
        position: "absolute",
        bottom: "-75px",
        height: "75px",
        marginLeft: "30px",
        left: 0,
        width: "90%",
    }
});

const AskRalphie = () => {
    const classes = useStyles();
    const [isRelated, setIsRelated] = useState(true);
    const [isSupportBtn, setIsSupportBtn] = useState(true);
    const hideExtraInfo = (val) => {
        setIsSupportBtn(val);
        setIsRelated(val);
    };
    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot}>
                <Box marginTop="40px" marginBottom="8px" textAlign="center">
                    <img alt="brand logo" src="/ralphieLogo.svg" width="150px"/>
                </Box>
                <Box marginTop="40px" marginBottom="8px">
                    <Typography align="center" className={classes.askRalphieHeaderFont}>
                        {!!isRelated &&
                        <div className={classes.askRalphieHeaderFontRelated}>Pet related questions?<br/></div>}
                        Ask Ralphie
                    </Typography>
                    <Typography align="center" className={classes.youCanAskFont}>
                        Type your question below and we’ll search our database for <br/> some helpful information.
                    </Typography>
                    <AskRalphieForm hideExtraInfo={hideExtraInfo}/>
                    <div className={classes.bottomDisclaimer}>
                        <p>Please note that this is general advice.
                            {/*For specific advice on your pet, please request an appointment with the Video vet by<a href={process.env.REACT_APP_PROD_URL}> clicking here.</a> */}
                        </p>
                    </div>
                </Box>
            </Card>
        </Container>
    );
};

export default AskRalphie;
